import ENDPOINT from "@/api/endpoints";
import { HTTP, HTTP_QLVB, HTTP_COMMON, buildQueries, HTTP_FILE } from "@/api/http-common";
import _cloneDeep from "lodash/cloneDeep";
import { formatAttachFilesData } from "@/utils/uploadFileUtils";

const formDataHeaderConfig = {
  headers: {
    "Content-Type": "multipart/form-data;"
  }
};

function getFormDataFromPayload(payload) {
  let formData = new FormData();
  for (let key in payload) {
    if (["NhiemVuXuLy"].indexOf(key) === -1) {
      formData.append(key, payload[key]);
    }
  }
  const NhiemVuXuLy = _cloneDeep(payload.NhiemVuXuLy);

  NhiemVuXuLy.forEach((file, index) => {
    formData = formatAttachFilesData(file, index, formData, "NhiemVuXuLy");
  });

  return formData;
}

export function callApiSetCurrentDonVi(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.AUTH.SET_CURRENT_DON_VI, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export const callApiGetDonViCurrentUser = () => {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.AUTH.GET_DON_VI_CURRENT_USER)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const callApiGetPermissions = () => {
  return new Promise((resolve, reject) => {
    return HTTP.get(ENDPOINT.AUTH.PERMISSION)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export function callApiGetPhanHoiMoiNhat(payload) {
  return HTTP({
    url: ENDPOINT.COMMON.GET_PHAN_HOI_MOI,
    method: "GET",
    params: payload
  });
}

export function callApiSearchCanBo(payload) {
  return HTTP({
    url: ENDPOINT.CAN_BO.SEARCH,
    method: "GET",
    params: payload
  });
}

export function callApiSearchLoaiVanBan(payload) {
  return HTTP({
    url: ENDPOINT.LOAI_VAN_BAN.SEARCH,
    method: "GET",
    params: payload
  });
}

export function callApiSearchLuong(payload) {
  return HTTP({
    url: ENDPOINT.LUONG.SEARCH,
    method: "GET",
    params: payload
  });
}

export function callApiThemLuong(payload) {
  return HTTP({
    url: ENDPOINT.LUONG.CREATE,
    method: "POST",
    data: payload
  });
}

export function callApiXoaLuong(payload) {
  return HTTP({
    url: ENDPOINT.LUONG.DELETE,
    method: "DELETE",
    data: payload
  });
}

export function callApiDownloadMultiFile(payload) {
  return HTTP({
    url: ENDPOINT.HSLT.DOWNLOAD_MULTIFILE,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiGetMultiCanBo(payload) {
  return HTTP({
    url: ENDPOINT.CAN_BO.GET_MULTI,
    method: "POST",
    data: payload
  });
}

export function callApiGetCanBoIgnore(payload) {
  return HTTP({
    url: ENDPOINT.CAN_BO.SEARCH_IGNORE,
    method: "POST",
    data: payload
  });
}

export function callApiGetCanBoVanThu(payload) {
  return HTTP({
    url: ENDPOINT.CAN_BO.SEARCH_VAN_THU,
    method: "GET",
    params: payload
  });
}

export function callApiGetAllSoDen(payload) {
  return HTTP({
    url: ENDPOINT.SO_VAN_BAN.GET_ALL,
    method: "GET",
    params: payload
  });
}

export function callApiGetAllSoDi(payload) {
  return HTTP({
    url: ENDPOINT.SO_VAN_BAN.GET_ALL_DON_VI,
    method: "GET",
    params: payload
  });
}

export function callApiGetAllSoDenTraCuu(payload) {
  return HTTP({
    url: ENDPOINT.SO_VAN_BAN.GET_ALL_TRA_CUU,
    method: "GET",
    params: payload
  });
}

export function callApiGetThongTinNguoiDung(payload) {
  return HTTP({
    url: ENDPOINT.CAN_BO.CHI_TIET,
    method: "POST",
    data: payload
  });
}

export function callApiUpdateThongTinNguoiDung(payload) {
  return HTTP({
    url: `${ENDPOINT.CAN_BO.NAME}/${payload.id}${ENDPOINT.CAN_BO.UPDATE_CAN_BO}`,
    method: "POST",
    data: payload.data
  });
}

export function callApiUpdateAnhCaNhan(payload) {
  return HTTP_FILE({
    url: `${ENDPOINT.CAN_BO.NAME}${ENDPOINT.CAN_BO.UPDATE_ANH}`,
    method: "POST",
    data: payload
  });
}

export function callApiUploadAnhCanBo(payload) {
  return HTTP_COMMON({
    url: `/CanBo${ENDPOINT.CAN_BO.UPLOAD}`,
    method: "PATCH",
    data: payload
  });
}

export function callApiUpdateAnhCanBo(payload) {
  return HTTP_FILE({
    url: `${ENDPOINT.CAN_BO.NAME}/${payload.Id}${ENDPOINT.CAN_BO.UPDATE_ANH_CAN_BO_COMMON}`,
    method: "POST",
    data: payload
  });
}

export function callApiThemMoiFile(payload) {
  const formData = getFormDataFromPayload(payload);
  return new Promise((resolve, reject) => {
    return HTTP_FILE.post(
      ENDPOINT.COMMON.UPLOAD_MULTI_FILE,
      formData,
      formDataHeaderConfig
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
export function callApiThemMoiFileHoSo(payload) {
  const formData = getFormDataFromPayload(payload);
  return new Promise((resolve, reject) => {
    return HTTP_FILE.post(
      ENDPOINT.HSLT.LAP_HO_SO.UPLOAD_FILE,
      formData,
      formDataHeaderConfig
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiDownloadFile(payload) {
  return new Promise((resolve, reject) => {
    return HTTP_FILE.get(
      `${ENDPOINT.COMMON.DOWNLOAD_FILE}?fileId=${payload.id}&token=${payload.token}&isKySo=false`,
      {
        responseType: "blob"
      }
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiDownloadFileQLVB(payload) {
  return new Promise((resolve, reject) => {
    return HTTP_QLVB.get(
      `${ENDPOINT.COMMON.DOWNLOAD_FILE}?fileId=${payload.id}&token=&isKySo=false`,
      {
        responseType: "blob"
      }
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiAddQRCode(payload) {
  return HTTP_FILE({
    url: ENDPOINT.COMMON.ADD_QR_CODE,
    method: "POST",
    data: payload
  });
}

export const callApiPreviewFile = (payload) => {
  return new Promise((resolve, reject) => {
    return HTTP_FILE.post(ENDPOINT.COMMON.PREVIEW_FILE, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const callApiGetFileInFolder = () => {
  return new Promise((resolve, reject) => {
    return HTTP_FILE.get(ENDPOINT.COMMON.GET_FILE_IN_FOLDER)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export function callApiChenLuong(payload) {
  return HTTP({
    url: `${ENDPOINT.LUONG.INSERT}${payload.Id}`,
    method: "PUT",
    data: payload.data
  });
}
/* eslint-disable */
export const callApiScanVanBan = (payload) => {
  var formData = new FormData();
  payload.files.forEach((item) => {
    if (item.type === "folder") {
      item.items.forEach((itemChild) => {
        formData.append("file", itemChild);
      });
    } else {
      formData.append("file", item);
    }
  });
  formData.append("type", payload.type);
  return new Promise((resolve, reject) => {
    return HTTP.post(
      ENDPOINT.COMMON.SCAN_VAN_BAN,
      formData,
      formDataHeaderConfig
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};


export const callApiGetAccessTokenFromIoC = (payload) => {
  return new Promise((resolve, reject) => {
    return HTTP_COMMON.get(`${ENDPOINT.COMMON.GET_ACCESS_TOKEN}?${buildQueries(payload)}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export const callApiGetImage = (payload) => {
  return new Promise((resolve, reject) => {
    return HTTP_COMMON.post(ENDPOINT.COMMON.GET_IMAGE, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export const callApiKyDienTu = (payload) => {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.COMMON.KY_DIEN_TU, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
}


export const callApiChangeGenerateSetupCode = (payload) => {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.COMMON.AUTHENTICATOR.GENERATE_SETUP_CODE_2FA, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          resolve(error)
          reject(error);
        });
  });
}

export const callApiConfirmUsing = (payload) => {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.COMMON.AUTHENTICATOR.CONFIRM_USING_2FA, payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          resolve(error)
          reject(error);
        });
  });
}

export const callApiValidateLogin = (payload) => {
  return new Promise((resolve, reject) => {
    return HTTP.post(ENDPOINT.COMMON.AUTHENTICATOR.VALIDATE_2FA, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          resolve(error)
          reject(error);
        });
  });
}

export function callApiGetAppId(payload) {
  return new Promise((resolve, reject) => {
    return HTTP_COMMON.get(`${ENDPOINT.COMMON.GET_APP_CODE}/${payload}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          resolve(error)
          reject(error);
        });
  });
}

export const callApiGetAccessToken = (payload) => {
  return new Promise((resolve, reject) => {
    return HTTP_COMMON.get(`${ENDPOINT.COMMON.GET_ACCES_TOKEN_IFRAME}?${buildQueries(payload)}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
  });
}

export const callApGetTreeDonVi = (payload) => {
  return new Promise((resolve, reject) => {
    return HTTP_COMMON.get(ENDPOINT.COMMON.DON_VI.GET_TREE, payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error)
        reject(error);
      });
  });
}
